$(document).ready(function() {
 if (typeof window.auto_lastValue == 'undefined') {
    window.auto_lastValue = {};
  }
  /* autocomplete 1 */
  $("#id_autocomplete_7a6f04ca0aa35988").bind('keyup',auto_focusOut);
  if ($("#searchSoundGuide").length > 0) {
    $("#searchSoundGuide").autocomplete({
      extraParams: {"output":"ajax"},
      originSearch: "searchall",
      autoAddOriginURL: true,
      minChars: 2,
      maxItemsToShow: 40,
      onItemSelect: function (data, autocompleter) { auto_onItemSelect(auto_selectItem, data, autocompleter); },
      preventDefaultReturn: false,
      beforeUseConverter: auto_beforeUseConverter,
      url: "/ajax/gids",
      disableQuotes: true
    });
  }
});

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
